<template>
    <card-component title="Detalle de Lección" subtitle="Notas por ejercicio" class="has-table has-mobile-sort-spaced" >
        <div slot="headerRight" class="card-header-icon">
          <div class="columns">
            <div class="column">
              <table-filter @filtered="applyFilter"/>
            </div>
          </div>
        </div>
        <b-table
            slot="content"
            :data="exercises"
            :bordered="true"
            :opened-detailed.sync="defaultOpenedDetails"
            :striped="true"
            :show-detail-icon="true"
            detailed
            :mobile-cards="false"
            class="selected-rows"
            @click="toggleDetails"
            :loading="isLoading" :key="componentKey">

            <template slot-scope="props" slot="header">
                <div>
                <b-tooltip
                  v-if="props.column.meta.official"
                  :label="`${props.column.meta.name} ${props.column.meta.lastname}`"
                  position="is-bottom"
                  >
                  <b-icon
                    style="margin-left: 0rem;"
                      icon="star"
                      size="is-small">
                  </b-icon>
                </b-tooltip>
                <br>
                {{ props.column.label }}
              </div>
            </template>

            <template slot-scope="props">
                <b-table-column label="#" width="40" numeric centered class="'is-sticky-column-one'">
                    {{props.index + 1}}
                </b-table-column>

                <b-table-column field="name" label="Ejercicio">
                    {{props.row.name}}
                </b-table-column>

                <b-table-column field="coeficent" width="50"  label="Coef" centered>
                  <span v-if="!props.row.disabled_evaluate">
                    {{props.row.coefficient}}
                  </span>
                </b-table-column>

                <b-table-column v-for="(judge, judgeIndex) in judgesSelected" :meta="judge" :label="`${judge.name.charAt(0)} ${judge.lastname.charAt(0)}`" width="100" :key="`judge-${judgeIndex}`" :set="judgeResult = findScore(judge.id, props.row.judges_scores)" centered>
                  <span v-if="!props.row.disabled_evaluate" :style="getStyleScore(judgeResult.base_score)">
                    {{judgeResult.base_score }}
                  </span>
                </b-table-column>

                <b-table-column field="total" width="100" label="Total" :set="(totalScoreRow = props.row.total_score)">
                    <span v-if="!props.row.disabled_evaluate" class="totalScore">{{ totalScoreRow.toFixed(1) }}</span>
                </b-table-column>
            </template>

            <template slot="detail" slot-scope="props">
              <p><b>Descripción del Ejercicio</b></p>
              <div>
                  <tr v-for="action_position in props.row.actions_positions" :key="action_position.id">
                      <td>{{action_position.position ? action_position.position.name : ''}}</td>
                      <td>{{action_position.action ? action_position.action.name : ''}}</td>
                  </tr>
              </div>
              <p><b>Observaciones</b></p>
              <div>
                  <tr v-for="(judge, judgeObsIndex) in judgesSelected" :meta="judge"  :key="`judge-table-result-${judgeObsIndex}`" :set="judgeResult = findScore(judge.id, props.row.judges_scores)">
                      <td>{{ `${judge.lastname} ${judge.name}`}}</td>
                      <td>{{ judgeResult.observation ? judgeResult.observation : 'Sin observación'}}</td>
                  </tr>
              </div>
            </template>

            <template slot="footer" v-if="!isLoading && exercises.length > 0">
                <th class="" style="">
                </th>
                <th class="" style="">
                </th>
                <th class="" style="">
                </th>
                <th class="" style="width:40px">
                    <div class="th-wrap is-numeric"> Subtotal <br> Errores <br> Totales <br> Nota </div>
                </th>
                <th class="" style="width:40px" v-for="(judge, judgeIndex) in judgesSelected" :key="`judge-totals-${judgeIndex}`">
                    <div class="th-wrap"><p class="ft-totals">{{ judge.subtotal }}</p> <span class="ft-labels">pts</span> </div>
                    <div class="th-wrap"><p class="ft-totals">{{ judge.errors }}</p> <span class="ft-labels">pts</span></div>
                    <div class="th-wrap"><p class="ft-totals">{{ judge.total }}</p> <span class="ft-labels">pts</span> </div>
                    <!-- <div class="th-wrap is-centered"> {{ (totalJudgeResults[`judge-${judge.id}`] / judgeResultMap[`judge-${judge.id}`].length).toFixed(1) }}pts. </div> -->
                    <div class="th-wrap"><p class="ft-totals">{{ judge.final_score }}%</p></div>
                </th>
                <th class="" style="width:40px">
                    <div class="th-wrap"><p >{{ resultExecution.subtotal }}</p> <span class="ft-labels">pts</span> </div>
                    <div class="th-wrap"><p >{{ resultExecution.errors }}</p> <span class="ft-labels">pts</span> </div>
                    <div class="th-wrap"><p >{{ resultExecution.total }}</p> <span class="ft-labels">pts</span> </div>

                    <div class="th-wrap"><h1 class="title is-5 ">{{ resultExecution.final_score.toFixed(2) }}% </h1> </div>
                </th>
            </template>

            <section class="section" slot="empty">
              <div class="content has-text-grey has-text-centered">
                <template v-if="isLoading">
                  <p>
                    <b-icon icon="dots-horizontal" size="is-large" />
                  </p>
                  <p>Cargando datos...</p>
                </template>
                <template v-else>
                  <p>
                    <b-icon icon="horseshoe" size="is-large" />
                  </p>
                  <p>No hay datos&hellip;</p>
                </template>
              </div>
            </section>
        </b-table>
    </card-component>
</template>

<script>

import CardComponent from '@/components/CardComponent'
import ExerciseService from '@/services/ExerciseService'
import ExecutionService from '@/services/ExecutionService'
import TableFilter from './filters/TableFilter'

export default {
  props: {
    lessonId: {
      required: true
    },
    executionId: {
      required: true
    },
    lesson: {
      required: true
    },
    resultExecution: {
      required: true
    }
  },
  components: {
    CardComponent,
    TableFilter
  },
  created () {
    this.mapExercisesResults()
  },
  data () {
    return {
      isLoading: false,
      exercises: [],
      judges: [],
      defaultOpenedDetails: [],
      judgeResultMap: [],
      totalJudgeResults: [],
      totalBaseJudgeResults: [],
      total: 0,
      allErrors: 0,
      minScore: 1000,
      maxScore: 0,
      finalScore: 0,
      onlyOfficials: true,
      componentKey: 0
    }
  },
  methods: {
    applyFilter (data) {
      this.onlyOfficials = data.show_no_officials
      this.mapExercisesResults()
    },
    getStyleScore (score) {
      let style
      if (this.maxScore === score) {
        style = 'color: #23d160'
      } else if (this.minScore === score && score < 6.0) {
        style = 'color: #ff3860 '
      }
      return style
    },
    toggleDetails (row) {
      let id = row.id
      let searchedRow = this.defaultOpenedDetails.find(x => x.id === id)
      if (searchedRow) {
        this.defaultOpenedDetails = []
      } else {
        this.defaultOpenedDetails = [row]
      }
    },
    async mapExercisesResults () {
      this.isLoading = true
      let exectisesList = await this.getExercises()
      let executionResults = await this.getExecutionSummary()
      let exercisesResults = executionResults.exercises
      let judgeResultsExecutions = await this.getJudgesResultsExecutions()
      let judges = await this.getJudgesInresults()

      this.judges = judges.map((judge, index) => {
        let judgeResult = this.findResult(judge.id, judgeResultsExecutions)
        return {
          ...judge,
          ...judgeResult
        }
      })
      this.judgesSelected = this.selectJudges()

      let mapExercises = exercisesResults.map((exercise, index) => {
        let exerciseInfo = exectisesList.find((x) => x.order === exercise.order)
        if (exerciseInfo && !exerciseInfo.disabled_evaluate) {
          let judgesScores = exercise.judges_scores

          for (let indexJ = 0; indexJ < judgesScores.length; indexJ++) {
            const score = judgesScores[indexJ]
            let baseScore = score.base_score
            this.minScore = (index === 0 && indexJ === 0) || (this.minScore > baseScore) ? baseScore : this.minScore
            this.maxScore = this.maxScore < baseScore ? baseScore : this.maxScore
          }
        }
        return {
          ...exercise,
          ...exerciseInfo
        }
      })
      this.forceRerender()
      this.exercises = mapExercises
      this.isLoading = false
    },
    async getExercises () {
      if (this.lessonId == null) {
        return []
      }
      let params = {
        'include[0]': 'actionsPositions.action',
        'include[1]': 'actionsPositions.position'
      }
      let response = await ExerciseService.getExercises(this.lessonId, params)
      return response.data.data
    },
    async getJudgesInresults () {
      let response = await ExecutionService.getJudgesInresults(this.executionId)
      return response.data.data
    },
    async getJudgesResultsExecutions () {
      let response = await ExecutionService.getJudgesResultsExecutions(this.executionId)
      return response ? response.data.data : []
    },
    async getExecutionSummary () {
      let params
      if (!this.onlyOfficials) {
        params = {
          'show_no_officials': true
        }
      }
      let response = await ExecutionService.getResultSummary(this.executionId, params)
      return response.data.data
    },
    findResult (id, array) {
      let result = array.find((x) => x.judge_id === id)
      if (result) {
        return {
          'total': result.total,
          'subtotal': result.subtotal,
          'errors': result.errors,
          'duration': result.duration
        }
      } else {
        return {}
      }
    },
    findScore (id, scores) {
      let result = scores.find((x) => x.judge_id === id)
      if (result) {
        return result
      } else {
        return {
          duration: null,
          errors: null,
          final_score: null,
          id: null,
          lastname: null,
          name: null,
          official: null,
          subtotal: null,
          total: null
        }
      }
    },
    selectJudges () {
      return this.onlyOfficials ? this.judges.filter((x) => x.official === true) : this.judges
    },
    forceRerender () {
      this.componentKey++
    }
  },
  watch: {
    lessonId () {
      this.mapExercisesResults()
    },
    executionId () {
      this.mapExercisesResults()
    },
    lesson () {
      this.mapExercisesResults()
    },
    minScore (value) {
      this.$emit('min-score', this.minScore)
    },
    maxScore (value) {
      this.$emit('max-score', this.maxScore)
    }
  }
}
</script>

<style>
  .table-footer{
    padding: 0.5rem 2rem !important;
  }

  .selected-rows tbody tr{
    cursor: pointer !important;
  }

  .totalScore {
    font-weight: 600;
  }

  .ft-totals{
    text-align: right;
    width: 100%;
  }
  .ft-labels{
    font-size: 0.7rem;
  }
</style>
